export enum Page {
    DeviceRegistration = "DEVICE_REGISTRATION",
    InstallationPreferences = "INSTALLATION_PREFERENCES",
    ImportConfiguration = "IMPORT_CONFIGURATION",
    DownloadPage = "DOWNLOAD_PAGE",
    loginByCodeToken = "LOGINBYCODETOKEN",
}

export enum ModuleTypeNames{
    Terminal = "IG Terminal App",
    UD ="Configuration Central",
    InterfaceServer = "Interface ServerIS",
}

export enum OnlineStatus{
    Online="Online",
    Offline="Offline"
}